import { ca } from '@cian/analytics';

import { EGeoName, EDealType, ECategory } from '../../types/share';
import { mapRegionValueToAnalytics, mapCategoryValueToAnalytics } from './utils';

export function trackRegionFilterChange(value: EGeoName) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AnalisysOnline',
    action: 'select_city',
    label: mapRegionValueToAnalytics(value),
  });
}

export function trackDealTypeFilterChange(value: EDealType) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AnalisysOnline',
    action: 'select_deal_type',
    label: value,
  });
}

export function trackCategoryFilterChange(value: ECategory) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AnalisysOnline',
    action: 'select_offer_type',
    label: mapCategoryValueToAnalytics(value),
  });
}
